import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AddressState {
  selectedAddressId: string | null;
  setSelectedAddressId: (id: string | null) => void;
}

export const useAddressStore = create<AddressState>()(
  persist(
    (set) => ({
      selectedAddressId: null,
      setSelectedAddressId: (id) => set({ selectedAddressId: id }),
    }),
    {
      name: 'address-selection-storage',
    }
  )
);
